import React from 'react';
import forLayout from '../../use/useForLayout';
import Header from '../Header';

export default React.memo(() => {
  const show = forLayout.useShowHeader();

  if (!show) return null;

  return <Header />;
});
